var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.306641,
    y: 0.484848,
    width: 95.2398,
    height: 95.2397,
    rx: 22.7941,
    fill: "#5E1B0C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.9305 70.4052C60.2463 70.4052 70.2302 60.4213 70.2302 48.1056C70.2302 35.7898 60.2463 25.806 47.9305 25.806C35.6148 25.806 25.6309 35.7898 25.6309 48.1056C25.6309 60.4213 35.6148 70.4052 47.9305 70.4052Z",
    fill: "#F8F7F2",
    stroke: "#FE6533",
    strokeWidth: 4.39914,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6309 48.1099H70.2302",
    stroke: "#FE6533",
    strokeWidth: 4.39914,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9355 25.806C53.5133 31.9124 56.6831 39.837 56.8553 48.1056C56.6831 56.3742 53.5133 64.2988 47.9355 70.4052C42.3577 64.2988 39.1879 56.3742 39.0156 48.1056C39.1879 39.837 42.3577 31.9124 47.9355 25.806Z",
    stroke: "#FE6533",
    strokeWidth: 4.39914,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricing);
export default __webpack_public_path__ + "static/media/Pricing.6ab8bcb0a59d7926dca552a922116bcd.svg";
export { ForwardRef as ReactComponent };